import React from 'react'
import {Provider} from 'react-redux'
import {ConnectedRouter} from 'react-router-redux'
import App from './App'
import history from '../history'
import store from '../redux'
import ReduxToastr from "react-redux-toastr";

if (module.hot) {
    module.hot.accept();
}
const Root = () => {
    return (
        <Provider store = {store}>
            <div>
            <ConnectedRouter history = {history}>
                <App />
            </ConnectedRouter>
            <ReduxToastr
                timeOut={3000}
                newestOnTop={false}
                preventDuplicates={false}
                position="top-right"
                transitionIn="fadeIn"
                transitionOut="fadeOut"
                progressBar={false}
                closeOnToastrClick
            />
                </div>
        </Provider>
    )
}

export default Root



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Root.js